document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('looksmaxxing-form');
  if (!form) return;

  const AYUBA_PRODUCTS = {
    creatine: {
      name: 'Creatine Monohydrate',
      handle: 'creatine-monohydrate-1000g',
      benefit: 'Kraft, Muskelmasse, kognitive Performance'
    },
    whey: {
      name: 'Premium Whey Protein',
      handle: 'premium-whey-protein-vanille-1kg',
      benefit: 'Muskelaufbau, Regeneration'
    },
    omega3: {
      name: 'Super Omega 3',
      handle: 'super-omega-3-120-softgels',
      benefit: 'Herz, Gehirn, Entzündung'
    },
    collagen: {
      name: 'Pure Sea Collagen',
      handle: 'pure-sea-collagen-120-kapseln',
      benefit: 'Haut, Haare, Nägel'
    },
    magnesium: {
      name: 'MAGNESIUM 4MAX',
      handle: 'magnesium-4max-60-kapseln',
      benefit: 'Muskeln, Schlaf'
    },
    melatonin: {
      name: 'Melatonin',
      handle: 'melatonin-75-kapseln',
      benefit: 'Einschlafzeit'
    },
    vitaminD: {
      name: 'Vitamin D3 + K2',
      handle: 'vitamin-d3-k2-1-700-tropfen-1-000-i-e-50ml',
      benefit: 'Immunsystem'
    },
    hydration: {
      name: 'Daily Hydration',
      handle: 'daily-hydration-basis-elektrolyte-fresh-mango-300g',
      benefit: 'Elektrolyte'
    },
    preWorkout: {
      name: 'Lite Energy Pre-Workout',
      handle: 'lite-energy-pre-workout-booster-fresh-orange-520g',
      benefit: 'Fokus, Energie'
    },
    multiShots: {
      name: 'All-In-One Multi Shots',
      handle: 'all-in-one-multi-shots-vitamins-minerals-amino-acids-herb-blend-50-vegane-shots-bio-orange-500ml',
      benefit: 'Vitamine'
    }
  };

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    
    // Show loading
    const resultsDiv = document.getElementById('results');
    resultsDiv.innerHTML = '<div style="text-align:center;padding:60px 20px;"><div style="border:4px solid #ff4d00;border-top:4px solid transparent;border-radius:50%;width:60px;height:60px;margin:0 auto 20px;animation:spin 1s linear infinite;"></div><p style="font-size:18px;color:#e5e5e5;">Generiere dein Protokoll...</p></div><style>@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}</style>';
    resultsDiv.classList.add('active');
    resultsDiv.scrollIntoView({behavior: 'smooth', block: 'start'});
    
    // Simulate processing time
    setTimeout(function() {
      const data = {
        age: parseInt(document.getElementById('age').value),
        sex: document.getElementById('sex').value,
        sleep: parseInt(document.getElementById('sleep').value),
        stress: parseInt(document.getElementById('stress').value),
        training: document.getElementById('training').value,
        bodyfat: document.getElementById('bodyfat').value,
        budget: document.getElementById('budget').value,
        priority: document.getElementById('priority').value,
        skinIssues: Array.from(document.querySelectorAll('input[id^="skin-"]:checked')).map(cb => cb.value),
        hairIssues: Array.from(document.querySelectorAll('input[id^="hair-"]:checked')).map(cb => cb.value)
      };
      
      let html = '<h2 style="margin-top:0;">Dein personalisiertes AyubaMAX™ Protokoll</h2>';
      
      // Phase 1
      html += '<div class="protocol-section"><h3>Phase 1: Sofort (0-7 Tage)</h3>';
      
      if (data.sleep <= 2) {
        html += '<div class="protocol-item"><strong>🔴 PRIORITÄT: Schlaf-Notfallprotokoll</strong>';
        html += '<p>Deine Schlafqualität ist kritisch niedrig.</p><ul>';
        html += '<li>Feste Bettzeit: 23:00 Uhr, Weckzeit: 7:00 Uhr (7 Tage konsequent)</li>';
        html += '<li>Kein Koffein nach 14:00 Uhr</li>';
        html += '<li>Raum 100% abdunkeln, Temperatur 16-18°C</li>';
        html += '<li>30 min Morgen-Sonnenlicht direkt nach Aufwachen</li>';
        html += '<li>Bildschirme 2h vor Bett minimieren</li></ul></div>';
      } else if (data.sleep === 3) {
        html += '<div class="protocol-item"><strong>Schlaf-Optimierung</strong><ul>';
        html += '<li>Schlaf-Konsistenz: Gleiche Zeiten auch am Wochenende</li>';
        html += '<li>Koffein-Cutoff: 10h vor Schlafenszeit</li>';
        html += '<li>Abend-Routine: 30 min Wind-Down ohne Bildschirme</li></ul></div>';
      }
      
      if (data.stress >= 4) {
        html += '<div class="protocol-item"><strong>⚠ Stress-Reduktion (Akut)</strong>';
        html += '<p>Chronischer Stress erhöht Cortisol → Gesichtsschwellung, Akne-Trigger, Fetteinlagerung.</p><ul>';
        html += '<li>Tägliche 10-min Meditation (Headspace, Calm)</li>';
        html += '<li>20 min Spaziergang outdoor täglich</li>';
        html += '<li>Soziale Interaktion priorisieren</li>';
        html += '<li>Bildschirmzeit reduzieren</li></ul></div>';
      }
      
      html += '<div class="protocol-item"><strong>Wasser & Elektrolyt-Management</strong><ul>';
      html += '<li>Baseline: 30-35ml/kg Körpergewicht täglich</li>';
      html += '<li>Morgens: 500ml mit Prise Salz</li>';
      html += '<li>Urin-Farbe: Pale Yellow als Target</li>';
      html += '<li>Alkohol reduzieren (dehydriert, erhöht Gesichtsschwellung)</li></ul></div>';
      
      html += '<div class="protocol-item"><strong>Haltungs-Awareness</strong><ul>';
      html += '<li>Stündlich: Schultern zurück, Brust raus, Kinn eingezogen</li>';
      html += '<li>Bildschirm auf Augenhöhe</li>';
      html += '<li>Beim Gehen: Aufrechte Haltung signalisiert Dominanz</li></ul></div>';
      html += '</div>';
      
      // Phase 2
      html += '<div class="protocol-section"><h3>Phase 2: Kurzfristig (2-6 Wochen)</h3>';
      
      if (data.training === 'none') {
        html += '<div class="protocol-item"><strong>Krafttraining Start (PRIORITÄT)</strong>';
        html += '<p>Höchste ROI-Intervention für Körperästhetik.</p><ul>';
        html += '<li>Frequenz: 3×/Woche (Mo/Mi/Fr)</li>';
        html += '<li>Ganzkörper-Routine: Squat, Bench Press, Rows, Overhead Press, Deadlift</li>';
        html += '<li>3 Sätze × 8-12 Wiederholungen</li>';
        html += '<li>Progressive Overload: Jede Woche +2.5kg oder +1 Wiederholung</li></ul></div>';
      } else if (data.training === 'beginner') {
        html += '<div class="protocol-item"><strong>Training Intensivierung</strong><ul>';
        html += '<li>Volumen erhöhen: 4×/Woche Training</li>';
        html += '<li>Upper/Lower Split implementieren</li>';
        html += '<li>Isolation für Schwachstellen</li></ul></div>';
      } else if (data.training === 'intermediate' || data.training === 'advanced') {
        html += '<div class="protocol-item"><strong>Training Optimierung</strong><ul>';
        html += '<li>Volumen-Phases: 10-20 Sets/Muskelgruppe/Woche</li>';
        html += '<li>Deload jede 4. Woche</li>';
        html += '<li>Haltungs-spezifisch: Face Pulls, Neck Curls</li></ul></div>';
      }
      
      if (data.bodyfat === 'high' || data.bodyfat === 'average') {
        html += '<div class="protocol-item"><strong>Körperfett-Reduktion Start</strong>';
        html += '<p>Faziale Definition verbessern durch moderate Fettreduktion.</p><ul>';
        html += '<li>Kaloriendefizit: 300-500 kcal/Tag (0.5-1% KG/Woche)</li>';
        html += '<li>Protein hochhalten: 2.0g/kg Körpergewicht</li>';
        html += '<li>Krafttraining beibehalten (Muskel-Erhalt)</li>';
        html += '<li>Tracking: Wöchentliche Fotos + Taillenumfang</li></ul></div>';
      }
      
      html += '<div class="protocol-item"><strong>UV-Schutz Implementation</strong>';
      html += '<p>Startet Photoaging-Prävention.</p><ul>';
      html += '<li>Täglicher Breitspektrum-Sonnenschutz SPF 30+ (auch indoor, Winter)</li>';
      html += '<li>Apply: 2 mg/cm² (großzügige Menge)</li>';
      html += '<li>Reapply: Alle 2h bei Outdoor-Exposition</li></ul></div>';
      
      if (data.skinIssues.length > 0) {
        html += '<div class="protocol-item"><strong>Haut-Routine Start</strong><ul>';
        if (data.skinIssues.includes('acne')) {
          html += '<li><strong>Akne:</strong> Benzoylperoxid 2.5% (morgens) + OTC Retinol 0.5% (abends 2×/Woche start)</li>';
        }
        if (data.skinIssues.includes('aging')) {
          html += '<li><strong>Anti-Aging:</strong> Vitamin C Serum (morgens) + Retinol (abends)</li>';
        }
        if (data.skinIssues.includes('pigmentation')) {
          html += '<li><strong>Pigmentierung:</strong> Niacinamid 5% (morgens+abends)</li>';
        }
        if (data.skinIssues.includes('texture')) {
          html += '<li><strong>Textur:</strong> AHA 5-10% 2×/Woche</li>';
        }
        if (data.skinIssues.includes('redness')) {
          html += '<li><strong>Rötungen:</strong> Azelainsäure 10%</li>';
        }
        if (data.skinIssues.includes('dryness')) {
          html += '<li><strong>Trockenheit:</strong> Ceramid-Moisturizer 2×/Tag</li>';
        }
        html += '<li>Gentle Cleanser 2×/Tag</li>';
        html += '<li>Moisturizer nach allen Actives</li>';
        html += '<li>Sonnenschutz IMMER morgens (final step)</li></ul></div>';
      }
      html += '</div>';
      
      // Phase 3
      html += '<div class="protocol-section"><h3>Phase 3: Mittelfristig (2-6 Monate)</h3>';
      
      if (data.skinIssues.includes('aging') || data.skinIssues.includes('acne')) {
        html += '<div class="protocol-item"><strong>Retinoide Escalation (Consider Tretinoin)</strong>';
        html += '<p>Nach 8-12 Wochen OTC Retinol, consider Arzt-Konsultation für Tretinoin 0.025%.</p><ul>';
        html += '<li>Stärkste Anti-Aging + Akne Evidenz</li>';
        html += '<li>Requires Verschreibung</li>';
        html += '<li>Start langsam: 2×/Woche, graduell erhöhen</li>';
        html += '<li>Mandatory: Täglicher Sonnenschutz</li></ul></div>';
      }
      
      if (data.hairIssues.includes('thinning') || data.hairIssues.includes('shedding')) {
        html += '<div class="protocol-item"><strong>💊 Haar-Loss Treatment (Evidenzbasiert)</strong>';
        html += '<p style="margin-bottom:12px;">Zwei Hauptoptionen mit hoher wissenschaftlicher Evidenz:</p>';
        
        html += '<p style="margin:12px 0 8px 0;"><strong>Option 1: Minoxidil 5% (OTC - Start sofort möglich)</strong></p><ul>';
        html += '<li><strong>Evidenz:</strong> Hohe Evidenz (FDA-approved, stoppt Progression ~80%, Nachwachsen ~40-60%)</li>';
        html += '<li><strong>Anwendung:</strong> 2×/Tag topisch (Foam besser toleriert als Lösung)</li>';
        html += '<li><strong>Zeitrahmen:</strong> 4-6 Monate für sichtbare Resultate, ongoing use required</li>';
        html += '<li><strong>Nebenwirkungen:</strong> Kopfhaut-Irritation, initial Shedding (erste 2-4 Wochen), selten systemisch</li>';
        html += '<li><strong>Verfügbarkeit:</strong> Apotheke ohne Rezept</li></ul>';
        
        html += '<p style="margin:16px 0 8px 0;"><strong>Option 2: Finasterid 1mg (Verschreibungspflichtig)</strong></p><ul>';
        html += '<li><strong>Evidenz:</strong> Hohe Evidenz (stoppt Progression ~85-90%, Nachwachsen ~60-65%)</li>';
        html += '<li><strong>Mechanismus:</strong> Blockiert DHT-Produktion (Hauptursache für Haarausfall)</li>';
        html += '<li><strong>Zeitrahmen:</strong> 3-6 Monate für Stabilisierung, 12+ Monate für maximales Nachwachsen</li>';
        html += '<li><strong>Nebenwirkungen:</strong> Sexuelle Dysfunktion (2-4% in Studien, selten persistent), Mood-Changes (EMA Safety Warning)</li>';
        html += '<li><strong>Voraussetzung:</strong> Arzt-Konsultation, Mental Health Screening, informed consent</li>';
        html += '<li><strong>Nicht geeignet bei:</strong> Depression, Angststörung (ohne Abklärung)</li></ul>';
        
        html += '<p style="margin:16px 0 8px 0;"><strong>Empfohlene Strategie:</strong></p><ul>';
        html += '<li><strong>Start:</strong> Minoxidil 5% sofort (3-6 Monate testen)</li>';
        html += '<li><strong>Eskalation:</strong> Nach 3-6 Monaten Minoxidil → Arzt-Termin für Finasterid wenn insufficient</li>';
        html += '<li><strong>Kombination:</strong> Minoxidil + Finasterid = stärkste Evidenz (wenn toleriert)</li>';
        html += '<li><strong>Mikronährstoffe:</strong> Eisen + Vitamin D Bluttest (Defizite beheben)</li></ul>';
        
        html += '<p style="margin:16px 0 0 0;font-size:14px;color:#a0a0a0;"><strong>Wichtig:</strong> Beide Optionen erfordern langfristige Anwendung. Bei Absetzen kehrt Haarausfall zurück. Realistische Erwartungen: Stabilisierung wahrscheinlicher als dramatisches Nachwachsen.</p></div>';
      }
      
      html += '<div class="protocol-item"><strong>Ernährungs-Refinement</strong><ul>';
      html += '<li>Makro-Tracking: Protein 2.0g/kg, Fett 0.8g/kg, Rest Carbs</li>';
      html += '<li>Mikronährstoff-Density: 5+ Portionen Gemüse/Obst täglich</li>';
      html += '<li>Glykämische Last senken wenn Akne present</li></ul></div>';
      html += '</div>';
      
      // Ayuba Stack
      const selected = [];
      if (data.training !== 'none') {
        selected.push(AYUBA_PRODUCTS.creatine);
        selected.push(AYUBA_PRODUCTS.whey);
      }
      if (data.sleep <= 3 || data.stress >= 4) {
        selected.push(AYUBA_PRODUCTS.magnesium);
        if (data.sleep <= 2) selected.push(AYUBA_PRODUCTS.melatonin);
      }
      if (data.priority === 'skin' || data.skinIssues.length > 0) {
        selected.push(AYUBA_PRODUCTS.collagen);
        selected.push(AYUBA_PRODUCTS.omega3);
      }
      if (data.priority === 'hair' || data.hairIssues.length > 0) {
        selected.push(AYUBA_PRODUCTS.collagen);
      }
      if (data.priority === 'physique' && data.training !== 'none') {
        selected.push(AYUBA_PRODUCTS.preWorkout);
        selected.push(AYUBA_PRODUCTS.hydration);
      }
      if (data.priority === 'overall') {
        selected.push(AYUBA_PRODUCTS.multiShots);
        selected.push(AYUBA_PRODUCTS.vitaminD);
      }
      
      const unique = [...new Set(selected)];
      const limited = data.budget === 'low' ? unique.slice(0, 2) : data.budget === 'medium' ? unique.slice(0, 4) : unique.slice(0, 6);
      
      html += '<div class="protocol-section"><h3>Dein Ayuba Nutrition Performance Stack</h3>';
      html += '<p style="margin-bottom:15px;">Evidenzbasiert auf dein Profil abgestimmt:</p>';
      html += '<div class="product-stack">';
      limited.forEach(product => {
        html += '<div class="product-card">';
        html += '<div class="product-name">' + product.name + '</div>';
        html += '<div class="product-benefit">' + product.benefit + '</div>';
        html += '<div class="product-actions">';
        html += '<a href="/products/' + product.handle + '" class="btn btn-primary" style="padding:8px 12px;font-size:13px;width:100%;">Zum Produkt</a>';
        html += '</div></div>';
      });
      html += '</div></div>';
      
      // Tracking
      html += '<div class="protocol-section"><h3>Messwerte & Tracking</h3>';
      html += '<div class="protocol-item"><strong>Wöchentlich tracken:</strong><ul>';
      html += '<li>Progress-Fotos (gleiche Beleuchtung, Winkel, Tageszeit)</li>';
      html += '<li>Taillenumfang (nüchtern, gleiches Tageszeit)</li>';
      html += '<li>Gewicht (Trend über 7 Tage)</li>';
      html += '<li>Kraftwerte (Bench/Squat/Deadlift Progression)</li></ul></div>';
      html += '<div class="protocol-item"><strong>Täglich tracken:</strong><ul>';
      html += '<li>Schlafqualität (1-10 Score oder App)</li>';
      html += '<li>Schritte/NEAT</li>';
      html += '<li>Energie-Level (subjektiv 1-10)</li></ul></div></div>';
      
      // Warnings
      html += '<div class="warning-box"><h4>⚠ Wichtige Sicherheitshinweise</h4><ul>';
      html += '<li><strong>Kein medizinischer Rat:</strong> Dieses Protokoll ersetzt nicht professionelle medizinische Beratung. Konsultiere Arzt vor Start.</li>';
      html += '<li><strong>RED-S Warning:</strong> Stop sofort wenn: Amenorrhoe >3 Monate, persistente Fatigue, Mood-Disturbance.</li>';
      html += '<li><strong>Prescription Meds:</strong> Tretinoin, Finasterid, Isotretinoin require ärztliche Überwachung.</li>';
      html += '<li><strong>Finasterid Mental Health:</strong> Nicht verwenden bei Depression/Angst ohne psychiatrische Abklärung.</li>';
      html += '<li><strong>Ausgeschlossen:</strong> UV-Bräunung, Bone Smashing, extreme Dehydration, unapproved Peptide.</li>';
      html += '<li><strong>Mental Health:</strong> Bei Body Dysmorphic Disorder Symptomen → Mental Health Professional kontaktieren.</li></ul></div>';
      
      resultsDiv.innerHTML = html;
    }, 2000);
  });
});
